import React from 'react';

function HeartNotFill(props: object) {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.0066 3.10999C20.4959 2.599 19.8894 2.19364 19.222 1.91708C18.5545 1.64052 17.8391 1.49817 17.1166 1.49817C16.3941 1.49817 15.6787 1.64052 15.0113 1.91708C14.3438 2.19364 13.7374 2.599 13.2266 3.10999L12.1666 4.16999L11.1066 3.10999C10.0749 2.0783 8.67566 1.4987 7.21662 1.4987C5.75759 1.4987 4.35831 2.0783 3.32662 3.10999C2.29493 4.14169 1.71533 5.54096 1.71533 6.99999C1.71533 8.45903 2.29493 9.8583 3.32662 10.89L12.1666 19.73L21.0066 10.89C21.5176 10.3792 21.923 9.77281 22.1995 9.10535C22.4761 8.43789 22.6184 7.72248 22.6184 6.99999C22.6184 6.27751 22.4761 5.5621 22.1995 4.89464C21.923 4.22718 21.5176 3.62075 21.0066 3.10999Z"
        fill="black"
        fillOpacity="0.2"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeartNotFill;
